var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section__lk-content container-shadow fill-white m-0 pt-0"},[_c('div',{staticClass:"section__lk-subtitle"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }